import React from 'react';
import { inject, observer } from 'mobx-react';

import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';

import Shortcut from './Shortcut';

import './style.scss';

const PREFIX = 'shortcuts-container';

type Props = {
  firstInit: any;
  sessionStore: any;
  passedRef: any;
  tracker: any;
};

const Shortcuts = (props: Props) => {
  const {
    shortcutList = [],
    hideLiveAgentShortcuts,
    liveAgentShortcut,
    liveAgentShortcutIndex,
  } = props.firstInit.initStore;

  const renderShortcut = (shortcut: any, index: number) => {
    const { passedRef, tracker } = props;

    return (
      <Shortcut
        key={`shortcut-${index}`}
        index={index}
        shortcut={shortcut}
        passedRef={(ele: any) => passedRef(ele, index)}
        tracker={tracker}
      />
    );
  };

  const getDisplayShortcut = () => {
    if (!hideLiveAgentShortcuts && liveAgentShortcut) {
      const list = shortcutList.filter((item: any) => !item.need_hide_when_live_agent_shortcut_show);
      list.splice(liveAgentShortcutIndex, 0, liveAgentShortcut);
      return list;
    }

    return shortcutList;
  };

  return (
    <>
      {shortcutList.length ? (
        <div className={PREFIX}>
          <div className="shortcuts-list" id="shortcuts-list">
            {getDisplayShortcut().map((shortcut: any, index: any) => renderShortcut(shortcut, index))}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default tracker(inject(getChildInject('firstInit', 'sessionStore'))(observer(Shortcuts as React.FC<{}>)));
